import { Debug } from "./debug";
import { For } from "./for";
import { Show } from "./show";
import { Wrap } from "./wrap";
import { Wrapper } from "./wrapper";

export const Utils = {
  Debug,
  For,
  Show,
  Wrapper,
  Wrap
};
